// The brand logo from config, drawn as a mask so it takes the theme's logo colour: the red logo on
// light backgrounds, reversed (white) on dark, as the brand guidelines require. Never stretched.
import type { Shell } from '../app/types';

type Logo = Shell['branding']['logo'];

export function BrandLogo({ logo, variant = 'full', className = '' }: { logo?: Logo; variant?: 'full' | 'emblem'; className?: string }) {
  const src = variant === 'emblem' ? logo?.emblem ?? logo?.src : logo?.src;
  if (!src) return null;
  const url = src.replace(/["()\\\s]/g, '');
  return <span className={`brand-logo ${variant} ${className}`} role="img" aria-label={logo?.alt ?? 'Logo'} style={{ ['--logo' as any]: `url("${url}")` }} />;
}
